import React, { Fragment, useState } from 'react';
import { Button, Form, Alert, FloatingLabel, Card } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import Logo from '../../assets/images/logo.png'
import FuncionarioService from '../../services/funcionarios';
import '../../styles/login.scss'


const FormLogin = () => {
    const [cpf, setCPF] = useState("")
    const [senha, setSenha] = useState("")
    const [error, setError] = useState(false);
    const [direct, setDirect] = useState(false);


    function mascararCPF(cpf) {
        if (!cpf) return "";
        cpf = cpf.replace(/\D/g, "");
        if (cpf.length <= 3) return cpf;
        if (cpf.length <= 6) return cpf.replace(/(\d{3})(\d{1,3})/, "$1.$2");
        if (cpf.length <= 9) return cpf.replace(/(\d{3})(\d{3})(\d{1,3})/, "$1.$2.$3");
        return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{1,2})/, "$1.$2.$3-$4");
    }

    function normalizarCPF(cpf) {
        return cpf.replace(/\D/g, "");
    }

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const funcionario = await FuncionarioService.login(
                {
                    cpf: normalizarCPF(cpf),
                    senha: senha
                }
            )
            setDirect("/funcionarios")
        } catch (error) {
            setError(error)
        }
    }

    if (direct) {
        return <Navigate to={{ pathname: `${direct}` }} />
    }
    return (
        <Fragment>
            <Card className='box-login'>
                <Card.Img variant="top" src={Logo} className="logo-login" />
                <Card.Body>
                    <Form onSubmit={HandleSubmit}>
                        <Form.Group className="mb-3" controlId="cpf">
                            <FloatingLabel
                                label="CPF (apenas números)"
                                className="mb-3"
                            >
                                <Form.Control
                                    required
                                    type="text"
                                    name="cpf"
                                    value={mascararCPF(cpf)}
                                    onChange={(e) => {
                                        // remove tudo que não for número
                                        const apenasNumeros = e.target.value.replace(/\D/g, "");
                                        if (apenasNumeros.length > 11) {
                                            apenasNumeros = apenasNumeros.slice(0, 11);
                                        }
                                        setCPF(apenasNumeros);
                                    }}
                                />
                            </FloatingLabel>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="senha">
                            <FloatingLabel
                                label="Senha"
                                className="mb-3"
                            >

                                <Form.Control
                                    required
                                    type="password"
                                    name="senha"
                                    value={senha}
                                    onChange={e => setSenha(e.target.value)} />

                            </FloatingLabel>
                        </Form.Group>
                        {error && <Alert color="danger">CPF ou senha inválidos!</Alert>}
                        <Button variant="outline-light" type="submit">
                            Entrar
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
        </Fragment>
    )
}

export default FormLogin;